import { createFileRoute } from '@tanstack/react-router';
import { redirectToHealthReadiness } from '@/components/health-readiness/legacy-redirect';
import { domainNameItem } from '@/components/health-readiness/model';

/**
 * The old Health Check → Budget tab (T-0224, T-0242): Budget is a domain on
 * Health & Readiness. The redirect names it, and the Overview finds its id
 * in the composite read and opens it on the Domains tab; without a Budget
 * domain the first domain opens.
 */
export const Route = createFileRoute('/engagements/$engagementId/health/budget')({
  beforeLoad: ({ params }) => {
    throw redirectToHealthReadiness(params.engagementId, {
      tab: 'overview',
      hint: domainNameItem('Budget'),
    });
  },
});
